@use '@/styles/tokens' as *;

.status {
  display: inline-flex;
  gap: var(--space-1);
  align-items: center;
  font-size: 11px;
  font-weight: 500;
}

// AC (117367): Used is green, Not Used is yellow — these were swapped (Used showed blue/info,
// Not Used showed green/success).
.used {
  color: $color-success-700;
}

.notUsed {
  color: $color-warning-700;
}
